
import { Component, Vue } from 'vue-property-decorator';
import api from '@/api';
import FlagPicker from '@/components/FlagPicker.vue';
import { Route } from 'vue-router';
import Util from '@/utils/util';
import Swal from 'sweetalert2';

const { productCategory } = api;

@Component({
  components: { FlagPicker },
})
export default class swapOutProductCategoryForm extends Vue {
  private loading: boolean = false;

  private valid: boolean = false;

  private isEdit: boolean = false;

  private catId: number = 0;

  private productTypes: Array<{ text: string, value: number}> = [
    { text: '商品', value: 1 },
    { text: '點數', value: 2 },
    { text: '折價券', value: 4 },
  ];

  private form = {
    catName: '',
    productType: 0,
    sort: 0,
  }

  private get title() {
    return this.isEdit ? '修改' : '新增';
  }

  private setCatId(id: any) {
    this.catId = id;
  }

  private setIsEdit(status: boolean) {
    this.isEdit = status;
  }

  private rules = {
    catName: [this.requiredRule('名稱')],
    sort: [this.requiredRule('排序')],
  }

  private requiredRule(column: string) {
    return (v: any) => !Util.isNullOrEmpty(v) || `${column} 為必填`;
  }

  private async cancel() {
    await this.$router.back();
  }

  private async submit() {
    const form = this.$refs.form as any as { validate: () => boolean };
    if (form.validate()) {
      const { status } = this.isEdit
        ? await productCategory.edit(this.catId, this.form)
        : await productCategory.add(this.form);
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: `${this.title}成功` });
        this.$router.back();
      }
    }
  }

  private async mounted() {
    if (this.isEdit) {
      const { data } = await productCategory.get(this.catId);
      this.form = data;
    }
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: swapOutProductCategoryForm) => void) => void,
  ) {
    const isEdit = to.name === 'swapOutProductCategoryEdit';
    await next(async (vm) => {
      if (isEdit) {
        const { catId } = to.params;
        vm.setIsEdit(isEdit);
        vm.setCatId(catId);
      }
    });
  }
}
